












































import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/Logo.vue';
import LogoutButton from '@/components/Account/LogoutButton.vue';
import ChangeLanguage from '@/components/Account/ChangeLanguage.vue';
import { APPLICATION_USER_DATA } from '@/queries/Application';
import { GQL_applicationUserData_currentUser } from '../queries/__generated__/applicationUserData';
import { SmartQuery } from 'vue-apollo-decorator';
import ChangeUnit from '@/components/ChangeUnit.vue';
import Locale from '@/utils/locale';
import PermissionService from '@/utils/permission-service';
import ApplicationModeService from '@/utils/application-mode-service';
import authToken from '@/utils/auth-token';

@Component({
  components: {
    Logo,
    ChangeUnit,
    LogoutButton,
    ChangeLanguage,
    ApplicationModeSwitcher: () => import('@/layouts/modes/ApplicationModeSwitcher.vue'),
    InvoicingMode: () => import('@/layouts/modes/InvoicingMode.vue'),
    PaycheckMode: () => import('@/layouts/modes/PaycheckMode.vue'),
    LinkToFakturabank: () => import('@/components/LinkToFakturabank.vue'),
  },
})
export default class ApplicationLayout extends Vue {
  @SmartQuery({
    query: APPLICATION_USER_DATA,
    result({ data }) {
      const locale = Locale.get() || data.currentUser.locale;
      Locale.set(locale);
      this.$i18n.locale = locale;
      PermissionService.set(data.currentUser.permissions);
    },
  }) public currentUser!: GQL_applicationUserData_currentUser;

  public isDebugMode: boolean = process.env.VUE_APP_DEBUG_PAGES === 'true';
  private isProductionMode: boolean = process.env.NODE_ENV === 'production';

  public handleOpen = true;

  private ApplicationModeService = ApplicationModeService;

  private onStorageChange() {
    // on logout
    if (!authToken.get()) {
      this.$router.push({ name: 'Login' });
    }
  }
}
